import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { Observable, timer } from 'rxjs';
import { filter, take, map, switchMap, tap, timeout, catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectIsAuthReady, selectIsAuthenticated } from '../ngrx/auth/auth.selectors';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private store: Store, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    
    // Store the URL immediately
    if (state.url !== '/login') {
      sessionStorage.setItem('redirectUrl', state.url);
    }
    
    return this.store.select(selectIsAuthReady).pipe(
      filter(ready => ready),
      switchMap(() => this.store.select(selectIsAuthenticated)),
      map(isAuthenticated => {
        if (!isAuthenticated) {
          this.router.navigate(['/login']);
          return false;
        }
        return true;
      }),
      take(1),
      timeout({
        first: 5000,
        with: () => of(false).pipe(
          tap(() => {
            this.router.navigate(['/login']);
          })
        )
      }),
      catchError(error => {
        console.error('AuthGuard error:', error);
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
